import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GetUserId } from '@core/utils';
import { HttpClient } from '@angular/common/http';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';
import { GroupNewsList, NewsEntity, NewsList, Pagination, UserContentNewsList } from '@core/entities';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;
  private readonly _userId = GetUserId();

  find(pagination: Partial<Pagination>, queryParams?: FilterQuery): Observable<NewsList> {
    return this._http.get<any>(`${this._apiUrl}/posts/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }

  get(newsId: number): Observable<NewsEntity> {
    return this._http.get<any>(`${this._apiUrl}/get-news-by-id/${newsId}`).pipe(map((response) => response.result));
  }

  allGroupNews(pagination: Partial<Pagination>): Observable<GroupNewsList> {
    return this._http.get<any>(`${this._apiUrl}/get-group-news-by-user-id/${this._userId}/${pagination.page}/${pagination.pageSize}`);
  }

  create(formData: any) {
    return this._http.post<any>(`${this._apiUrl}/createNews`, formData);
  }

  update(newsId: number, formData: any) {
    return this._http.put<any>(`${this._apiUrl}/news/${newsId}`, formData);
  }

  delete(newsId: number) {
    return this._http.delete<any>(`${this._apiUrl}/news/${newsId}/user/${this._userId}`);
  }

  markAsRead() {
    return this._http.get(`${this._apiUrl}/mark-as-read/news`);
  }

  topFive(queryParams?: FilterQuery): Observable<NewsEntity[]> {
    return this._http.get<any>(`${this._apiUrl}/topNews/user/${this._userId}`, { params: queryParams });
  }

  getContentNews(pagination: Partial<Pagination>, queryParams?: FilterQuery): Observable<UserContentNewsList> {
    return this._http.get<any>(`${this._apiUrl}/getOwnerNews/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }

  //   User News Service
  getNewsByUserId(pagination: Partial<Pagination>, queryParams?: FilterQuery): Observable<NewsList> {
    return this._http.get<any>(`${this._apiUrl}/uposts/${this._userId}/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }
}
